<template>
  <div class="flex tagBox px-4">
    <div class="tagContent">
      <el-scrollbar ref="scrollbarRef" class="tagList py-2" horizontal>
        <!-- <el-tag
            v-for="item in visitedTags"
            class="border mr-2"
            :key="item.fullPath"
            :type="router.currentRoute.value.fullPath === item.fullPath ? 'primary' : 'info'"
            :effect="router.currentRoute.value.fullPath === item.fullPath ? 'dark' : 'light'"
            :closable="item.name !== 'Dashboard'"
            @close="handleCloseTag(item)"
        >
          <router-link :to="item.fullPath">{{ t(item.meta.title) }}{{ queryName }}</router-link>
        </el-tag> -->
        <div class="flex gap-4">
          <div class="dark:text-white flex gap-1 items-center w-fit px-5" :class="router.currentRoute.value.fullPath === item.fullPath ? 'primary' : 'info'" v-for="item in visitedTags" :key="item.fullPath">
            <router-link :to="item.fullPath">
              {{ t(item.meta.title) }}
            </router-link>
            <el-icon class="cursor-pointer" v-if="item.name !== 'Links' && item.name !== 'Assets' " @click="handleCloseTag(item)"><Close /></el-icon>
          </div>
        </div>
      </el-scrollbar>
      <!-- <el-icon class="tagContent_rightBtn control" @click="handleRefresh" :title="t('刷新')"><Refresh /></el-icon> -->
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

import { useTagsStore } from '@/store/tags'
import { computed, ref, nextTick, onMounted, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import { eventBus } from '@/views/eventBus'

const router = useRouter()
const store = useTagsStore()
const visitedTags = computed(() => store.visitedTags)

// // 处理链接编辑页tagName拼接query
// const queryName = computed(() => {
//   if (router.currentRoute.value.path.startsWith('/link/operate')) {
//     return router.currentRoute.value.query.name || ''
//   }
//   return ''
// })
const scrollbarRef = ref(null)
const contentmenuVisible = ref(false)

const handleRefresh = () => {
  store.deleteCachedTags(router.currentRoute.value)
  const { path, query } = router.currentRoute.value
  nextTick(() => {
    router.replace({
      path: '/redirect' + path,
      query
    })
  })
}

const handleCloseTag = (item) => {
  deleteTag()
  function deleteTag() {
    store.deleteVisitedTags(item)
    store.deleteCachedTags(item)
    if (item.fullPath === router.currentRoute.value.fullPath) {
      const latestView = visitedTags.value.slice(-1)[0]
      router.push(latestView.fullPath)
    }
  }
}

const clickEvent = () => {
  if (contentmenuVisible.value) {
    contentmenuVisible.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', clickEvent)
  eventBus.$on('deleteTag', (route) => handleCloseTag(route))
})
onBeforeUnmount(() => {
  document.removeEventListener('click', clickEvent)
})
</script>

<style lang="scss" scoped>
.tagBox {
  box-shadow: 0 1px 2px 0 rgba(0,0,0,.05);
  transition: all .2s;
  transform: translateZ(0);
  z-index: 100;
  flex: 1;
  width: 0;
  // position: absolute;
  // top: var(--itsop-header-height);
  // width: 100%;
  .contextMenu {
    z-index: 3000;
    box-shadow: 2px 2px 3px 0 rgba(0,0,0,.3);
    position: absolute;
    font-size: 12px;
    padding: 5px 0;
    color: var(--itsop-font-2);
    border-radius: 4px;
    background: #fff;
    li {
      padding: 4px 8px;
      cursor: pointer;
      &:hover {
        background: #eee;
      }
    }
  }
  .tagContent {
    width: var(--itsop-content-width);
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    display: flex;
    .tagList {
      white-space: nowrap;
      flex: 1;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .control {
      background: white;
      height: 100%;
      width: 2em;
      box-shadow: 0 2px 8px rgba(0,0,0,.2);
      cursor: pointer;
      z-index: 1;
    }
  }
}
.el-tag {
  &.is-closable {
    padding-right: 9px;
  }
}
.el-tag--info {
  background: #ffffff;
  border-radius: 0;
  color: var(--itsop-font-2);
}
.el-tag--primary {
  border-radius: 0;
}

.primary {
  color: var(--el-color-primary) !important;
  border-bottom: 2px solid var(--el-color-primary);
}
</style>